import {
  Component,
  OnInit,
  Input,
  ViewContainerRef,
  ViewEncapsulation
} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';
import { Router, ActivatedRoute, ParamMap, Params, NavigationStart, NavigationEnd } from '@angular/router';

import { RequestsServices } from '../../../services/requests.service';
import { UserService } from '../../../services/user.service';
import { StorageService } from '../../../services/storage.service';
import { PageBase } from '../../../page.base';
import { ToasterService } from '../../../services/toaster.service';
import { TranslateService } from '@ngx-translate/core';
import { HeaderMenuComponent } from '../../../components/header-menu/header-menu.component';
import { slugify } from '../../../utils/string';


@Component({
  selector: 'app-basic',
  templateUrl: './basic.component.html',
  providers: [ RequestsServices, StorageService, UserService ],
  encapsulation: ViewEncapsulation.None
})

export class BasicComponent implements OnInit {

  index:number = 1;

  public isLoading;
  public basicCampaigns;
  public specialCampaigns;
  public companyId;
  public basicSelectedToDownload = [];
  public specialSelectedToDownload = [];

  constructor(private translate: TranslateService,
    private toasterService: ToasterService,
    private request: RequestsServices,
    private route: ActivatedRoute,
    private router: Router,
    private storage: StorageService,
    private userService: UserService) {

    let languageCurrent = navigator.language;
    translate.addLangs(['en', 'pt-br']);
    translate.setDefaultLang('en');
    languageCurrent === 'pt-BR' ? translate.use('pt-br') : translate.use('en');
  }

  public ngOnInit(): void {
    window.scrollTo(0, 0);

    const companyAccount = this.userService.getLoggedAccount();
    const typeBusiness = this.userService.getTypeAccount();
    if (typeBusiness === 'company' && companyAccount) {
      this.getBasicCampaigns(companyAccount['id']);
      this.getSpecialCampaigns(companyAccount['id']);
    } else {
      alert('Conta de empresa inválida');
    }

  }

  private getBasicCampaigns(companyId): void {

    const filterObject: any = {
      where: {
        or: [
          { and: [ { companyId: null } ] },
          { companyId: companyId }
        ]
      },
      order: [ 'created_at DESC' ]
    };

    const createParameters = [{
      param: 'filter',
      value: JSON.stringify(filterObject)
    }];

    this.isLoading = true;
    this.request.get({path: 'campaign_basics', endPoint: '/', params: createParameters}).then((basicCampaigns) => {
      this.isLoading = false;
      this.basicCampaigns = basicCampaigns;
    });
  }

  private getSpecialCampaigns(companyId): void {

    const filterObject: any = {
      where: {
        or: [
          { and: [ { companyId: null } ] },
          { companyId: companyId }
        ]
      },
      order: [ 'created_at DESC' ]
    };

    const createParameters = [{
      param: 'filter',
      value: JSON.stringify(filterObject)
    }];

    this.isLoading = true;
    this.request.get({path: 'campaign_special', endPoint: '/', params: createParameters}).then((specialCampaigns) => {
      this.isLoading = false;
      this.specialCampaigns = specialCampaigns;
    });
  }

  public downloadFile(fileUrl): void {
    window.open(fileUrl, '_blank');
  }

  public downloadAllBasic(): void {
    for (const basicCamp of this.basicCampaigns) {
      this.downloadFile(basicCamp.files.edited);
      this.downloadFile(basicCamp.files.notEdited);
    }
  }

  public downloadSelectedBasic(): void {
    for (let i = 0; i < this.basicSelectedToDownload.length; i++) {
      if (this.basicSelectedToDownload[i] === true) {
        this.downloadFile(this.basicCampaigns[i].files.edited);
        this.downloadFile(this.basicCampaigns[i].files.notEdited);
      }
    }
  }

  public downloadAllSpecial(): void {
    for (const specialCamp of this.specialCampaigns) {
      this.downloadFile(specialCamp.files.edited);
      this.downloadFile(specialCamp.files.notEdited);
    }
  }

  public downloadSelectedSpecial(): void {
    for (let i = 0; i < this.specialSelectedToDownload.length; i++) {
      if (this.specialSelectedToDownload[i] === true) {
        this.downloadFile(this.specialCampaigns[i].files.edited);
        this.downloadFile(this.specialCampaigns[i].files.notEdited);
      }
    }
  }

  trackingEvent(name, type) {
    const category = 'admin:campanhas';
    const action = `campanhas-basicas:${slugify(name)}`;
    const label = `btn:${type}`;

    (window as any).sendEvent(category, action, label);
  }
}
